import React, { useContext, useEffect, useState } from 'react';
import CardToolbar from '../lib/ui/CardToolbar';
import CardPadding from '../lib/ui/CardPadding';
import { get, patch, put } from '../../util/api';
import WithLabel from '../lib/forms/WithLabel';
import InputField from '../lib/forms/simple/InputField';
import ButtonArea from '../lib/forms/ButtonArea';
import Button from '../lib/forms/simple/Button';
import Card from '../lib/ui/Card';
import CardLoadingSpinner from '../lib/ui/CardLoadingSpinner';
import ErrorMessage from '../lib/forms/ErrorMessage';
import NavigateAwayPrompt from '../lib/forms/NavigateAwayPrompt';
import TertiaryButton from '../lib/forms/simple/TertiaryButton';
import UserDataChangeCounter from '../../context/UserDataChangeCounter';
import { FormattedMessage, useIntl } from 'react-intl';

export default function ProfileLoginDetailsForm() {
	const { increment, value } = useContext(UserDataChangeCounter);
	const [ redirect, setRedirect ] = useState(null);
	const [ loading, setLoading ] = useState(false);
	const [ error, setError ] = useState(null);

	const [ username, setUsername ] = useState('');
	const [ email, setEmail ] = useState('');
	const intl = useIntl();

	useEffect(() => {
		get('/whoami').then(user => {
			setUsername(user.username);
			setEmail(user.email);
		});
	}, [ value ]);

	return <Card>
		<NavigateAwayPrompt redirect={redirect} />
		<CardToolbar title={intl.formatMessage({ id: "changeLoginDetails" })} />
		<CardPadding>
			<form onSubmit={event => {
				event.preventDefault();
				event.stopPropagation();
				setLoading(true);
				setError(null);
				put('/users/me/loginDetails', { username, email })
					.then(() => setRedirect('/profile'))
					.catch(e => {
						setLoading(false);
						setError(<FormattedMessage id="credentialsAlreadyInUse" />);
					})
					.finally(increment);
				return false;
			}}>
				{error && <ErrorMessage error={error} />}

				<WithLabel label={intl.formatMessage({ id: "username" })}>
					<InputField value={username} onChange={setUsername} />
				</WithLabel>

				<WithLabel label={intl.formatMessage({ id: "email" })}>
					<InputField value={email} onChange={setEmail} />
				</WithLabel>

				<ButtonArea>
					<TertiaryButton label={intl.formatMessage({ id: "cancel" })} onClick={() => setRedirect('/profile')} />
					<Button icon="check" label={intl.formatMessage({ id: "save" })} type="submit" />
				</ButtonArea>
				{loading && <CardLoadingSpinner />}
			</form>
		</CardPadding>
	</Card>;
}
